import common from "./common.json";
import header from "./header.json";
import landing from "./landing.json";
import login from "./login.json";
import logout from "./logout.json";
import register from "./register.json";

export default {
	landing,
	register,
	common,
	login,
	logout,
	header
};
